import { useContext, useState } from 'react';
import PostAJobCheckoutForm from '../PostAJobCheckoutForm/PostAJobCheckoutForm';
import PostAJobFormJobDetails from '../PostAJobFormJobDetails/PostAJobFormJobDetails';
import PostAJobFormCompanyDetails from '../PostAJobFormCompanyDetails/PostAJobFormCompanyDetails';
import { PostAJobContext } from '@/utils/context';
import { COMPANY, JOB, CHECKOUT } from '@/utils/constants';

const PostAJobFormComponent = () => {
  const { currentStep } = useContext(PostAJobContext);
  const [formState, setFormState] = useState({
    company: ``,
    companyLogoFilename: ``,
    companyLogoFile: null,
    companyDescription: ``,
    companyUrl: ``,
    title: ``,
    description: ``,
    tags: [],
    instructions: ``,
    minCompensation: 0,
    maxCompensation: 0,
    remote: false,
    locationCountry: ``,
    locationCity: ``,
    longitude: 0,
    latitude: 0,
    applyUrl: ``,
    email: ``,
  });
  const [errorsState, setErrorsState] = useState({
    company: false,
    title: false,
    tags: false,
    location: false,
    description: false,
    applyUrl: false,
    email: false,
  });

  const postAJobProps = {
    formState,
    setFormState,
    errorsState,
    setErrorsState,
  };

  switch (currentStep) {
    case COMPANY:
      return <PostAJobFormCompanyDetails postAJobProps={postAJobProps} />;
    case JOB:
      return <PostAJobFormJobDetails postAJobProps={postAJobProps} />;
    case CHECKOUT:
      return <PostAJobCheckoutForm postAJobProps={postAJobProps} />;
    default:
      return null;
  }
};

export default PostAJobFormComponent;
